export default "__VITE_ASSET__FPJ_XJ7a__"